"use client";

import { useCallback, useSyncExternalStore } from "react";

/**
 * Reactive CSS media query. SSR snapshot is `false` — only use it for
 * client-only surfaces (the workspace never prerenders) or where a
 * narrow-first flash is acceptable.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (listener: () => void) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", listener);
      return () => mql.removeEventListener("change", listener);
    },
    [query],
  );

  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false,
  );
}
